import { render, staticRenderFns } from "./PesquisaBot.vue?vue&type=template&id=0a824c4e&scoped=true"
import script from "./PesquisaBot.vue?vue&type=script&lang=js"
export * from "./PesquisaBot.vue?vue&type=script&lang=js"
import style0 from "./PesquisaBot.vue?vue&type=style&index=0&id=0a824c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a824c4e",
  null
  
)

export default component.exports